/* ============================================================================
   osteva-slider.js — Drag-to-Scroll fuer JEDEN horizontalen Scroller im Shop.

   WARUM DAS EXISTIERT
   -------------------
   Alle Osteva-Slider sind native Scroll-Container: `overflow-x: auto` plus
   `scroll-snap-type: x mandatory`. Auf dem Desktop funktioniert das. Auf dem
   Telefon nicht zuverlaessig: sobald die Karten hoch sind (gemessen 335px bis
   743px), sperrt der mobile Browser die Geste nach dem ersten Millimeter auf
   die vertikale Achse und die Seite scrollt weiter, statt dass der Slider
   weiterlaeuft. Der Nutzer sieht die Nachbarkarte hervorlugen, kommt aber
   nicht hin.

   Diese Achsen-Heuristik laesst sich nicht per CSS abschalten - man kann sie
   nur umgehen, indem man das horizontale Scrollen selbst uebernimmt:

     touch-action: pan-y pinch-zoom
       -> Der Browser behaelt das vertikale Seitenscrollen und das Zoomen.
          Alles Horizontale wird an JavaScript durchgereicht.

   Danach setzt `pointermove` `scrollLeft` direkt. 1:1, ohne Verzoegerung.

   WICHTIG: `touch-action` wird hier im Skript gesetzt, NICHT im Stylesheet.
   Faellt das Skript aus (Fehler, blockiert, alter Browser ohne Pointer
   Events), bleibt `touch-action: auto` stehen und das native Scrollen
   funktioniert wie bisher. Wer die Zeile ins CSS verschiebt, nimmt sich
   dieses Sicherheitsnetz weg.

   SCROLL-SNAP
   -----------
   Waehrend des Ziehens wird Snapping abgeschaltet, sonst zerrt der Browser
   bei jedem `scrollLeft`-Schreibvorgang zum naechsten Snap-Punkt zurueck und
   die Bewegung ruckelt. Beim Loslassen fahren wir selbst weich auf die
   passende Karte und stellen den urspruenglichen Wert danach wieder her.

   Ebenso `scroll-behavior`: steht auf einem Container `smooth` (z. B.
   `.edu__scroller`), wuerde jeder Schreibvorgang animiert - das Ziehen
   haengt dann sichtbar hinterher. Waehrend des Ziehens deshalb `auto`.

   Registrierung: automatisch. Jedes Element, dessen berechnetes `overflow-x`
   auf `auto`/`scroll` steht und das breiter ist als sein sichtbarer Bereich,
   wird uebernommen. Fremd-Karussells mit eigener Touch-Logik (Swiper, Slick,
   Splide, Flickity) sind ausgenommen - zwei Drag-Implementierungen auf
   demselben Element heben sich gegenseitig auf.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__ostSlider) return;
  window.__ostSlider = true;

  /* Ohne Pointer Events kein Drag - dann bleibt es beim nativen Verhalten. */
  if (!window.PointerEvent) return;

  var READY = 'data-ost-slider-ready';

  /* Ab dieser Strecke gilt eine Geste als bewusstes Wischen. Darunter ist es
     ein Tippen und der Klick auf Karte/Link muss durchgehen. */
  var THRESHOLD = 8;

  /* px pro ms. Darueber gilt es als Schwung und wir gehen eine Karte weiter,
     auch wenn die aktuelle noch naeher liegt. */
  var FLICK = 0.35;

  /* Karussells mit eigener Touch-Logik. */
  var FOREIGN = '.swiper, .swiper-container, .slick-slider, .slick-list, .splide, .flickity-enabled, .product-slider';

  /* Ausklapp-Panels des Themes. Die Filter-Schublade der Suchseite meldet im
     zugeklappten Zustand `scrollWidth - clientWidth` von 63 bis 154px und
     sieht dadurch wie ein waagerechter Slider aus - aufgeklappt ist sie
     keiner. Uebernaehmen wir sie, wuerde ein leicht schraeger Wisch ueber die
     Filterliste den darauf folgenden Klick auf einen Filter schlucken
     (siehe Klick-Sperre unten). Es gibt hier nichts zu gewinnen, also raus. */
  var THEME_PANELS = '.mobile-facets, .facets, .drawer, .menu-drawer, .cart-drawer';

  function isScroller(el) {
    if (el === document.body || el === document.documentElement) return false;
    if (el.hasAttribute(READY)) return false;
    if (el.closest(FOREIGN)) return false;
    if (el.closest(THEME_PANELS)) return false;
    var ox = window.getComputedStyle(el).overflowX;
    if (ox !== 'auto' && ox !== 'scroll') return false;
    return el.scrollWidth - el.clientWidth > 4;
  }

  /* Scroll-Positionen der Karten, relativ zum Scroll-Ursprung.

     Nicht jeder Slider haengt seine Karten direkt in den Scroll-Container.
     `osteva-pdp-expert` schiebt eine Spur dazwischen:

       .exp__viewport  (scrollt)
         └ .exp__track  (eine einzige Spur)
             ├ .exp__slide
             ├ .exp__slide
             └ ...

     Wer hier nur eine Ebene tief schaut, findet genau ein Kind und damit
     genau einen Halt bei 0 - jeder Wischer waere zum Anfang zurueck-
     gefallen und die Section liesse sich gar nicht bedienen. Gemessen:
     Viewport 355px, Inhalt 1147px, aber nur ein Kind.

     Deshalb steigen wir durch solche Zwischen-Spuren hindurch. Abbruch,
     sobald eine Ebene mehr als ein Kind hat - das sind die Karten. Die
     Tiefenbegrenzung schuetzt vor tief verschachtelten Einzelkindern. */
  function track(el) {
    var host = el;
    for (var d = 0; d < 3; d++) {
      if (host.children.length !== 1) break;
      if (host.children[0].children.length < 2) break;
      host = host.children[0];
    }
    return host;
  }

  function stops(el) {
    /* Der Bezugspunkt bleibt der Scroll-Container, auch wenn die Karten
       eine Ebene tiefer liegen - `scrollLeft` gehoert ja ihm. */
    var base = el.getBoundingClientRect().left - el.scrollLeft;
    var host = track(el);
    var out = [];
    for (var i = 0; i < host.children.length; i++) {
      var kid = host.children[i];
      if (window.getComputedStyle(kid).display === 'none') continue;
      out.push(Math.round(kid.getBoundingClientRect().left - base));
    }
    return out;
  }

  function enhance(el) {
    el.setAttribute(READY, '1');

    el.style.touchAction = 'pan-y pinch-zoom';

    var pid = null;
    var startX = 0, startY = 0, startLeft = 0;
    var lastX = 0, lastT = 0, vx = 0;
    var dragging = false;
    var moved = false;
    var restore = null;

    /* Die Originalwerte werden GENAU EINMAL hier gelesen, nicht bei jedem
       Zieh-Vorgang.

       Vorher standen sie im pointermove und wurden bei jedem Drag neu aus
       `el.style` geholt. Das geht schief, sobald zwei Wischer schneller
       aufeinander folgen als die 420ms, nach denen `stopDrag` das Snapping
       zurueckstellt: der zweite Drag liest dann das noch gesetzte 'none'
       als "Originalwert" und schreibt es hinterher als vermeintlichen
       Ausgangszustand fest. Scroll-Snap ist damit fuer den Rest der
       Seitensitzung tot - gemessen: `el.style.scrollSnapType === "none"`,
       obwohl das Stylesheet `x mandatory` vorgibt. Auf dem Telefon sind
       zwei Wischer in unter 420ms voellig normal.

       Beide Werte sind hier praktisch immer '' (die Sections setzen Snap
       ueber ihr Stylesheet, nicht inline). '' zurueckzuschreiben gibt die
       Kontrolle korrekt an das Stylesheet zurueck. */
    var snapBefore = el.style.scrollSnapType;
    var behaviorBefore = el.style.scrollBehavior;

    function target() {
      var pos = stops(el);
      var max = el.scrollWidth - el.clientWidth;
      if (!pos.length) return Math.max(0, Math.min(max, el.scrollLeft));

      var cur = el.scrollLeft;
      var idx = 0, best = Infinity;
      for (var i = 0; i < pos.length; i++) {
        var d = Math.abs(pos[i] - cur);
        if (d < best) { best = d; idx = i; }
      }

      if (Math.abs(vx) > FLICK) {
        /* vx < 0 heisst: der Finger ging nach links, es soll vorwaerts gehen. */
        var dir = vx < 0 ? 1 : -1;
        if ((dir > 0 && pos[idx] <= cur) || (dir < 0 && pos[idx] >= cur)) idx += dir;
        idx = Math.max(0, Math.min(pos.length - 1, idx));
      }

      return Math.max(0, Math.min(max, pos[idx]));
    }

    function stopDrag() {
      dragging = false;
      pid = null;
      el.classList.remove('ost-dragging');
      el.style.scrollBehavior = behaviorBefore;

      var to = target();
      if (typeof el.scrollTo === 'function') {
        el.scrollTo({ left: to, behavior: 'smooth' });
      } else {
        el.scrollLeft = to;
      }

      /* Snapping erst wieder anschalten, wenn die weiche Fahrt durch ist -
         sonst schnappt der Browser mitten in der Bewegung hart um. */
      if (restore) clearTimeout(restore);
      restore = setTimeout(function () {
        el.style.scrollSnapType = snapBefore;
        restore = null;
      }, 420);
    }

    el.addEventListener('pointerdown', function (e) {
      if (!e.isPrimary) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      /* In Formularfeldern gewinnt die Texteingabe. */
      if (e.target.closest('input, textarea, select, [contenteditable="true"]')) return;

      /* Laeuft noch eine Rueckstellung aus dem vorigen Wischer, wird sie
         hier abgeraeumt - sonst schaltet sie mitten im neuen Zieh-Vorgang
         das Snapping wieder an und der Slider ruckt weg. */
      if (restore) { clearTimeout(restore); restore = null; }

      pid = e.pointerId;
      startX = lastX = e.clientX;
      startY = e.clientY;
      startLeft = el.scrollLeft;
      lastT = e.timeStamp;
      vx = 0;
      dragging = false;
      moved = false;
    });

    el.addEventListener('pointermove', function (e) {
      if (e.pointerId !== pid) return;

      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (!dragging) {
        if (Math.abs(dx) < THRESHOLD) return;
        /* Ueberwiegend senkrecht: Geste abgeben, die Seite soll scrollen. */
        if (Math.abs(dx) <= Math.abs(dy)) { pid = null; return; }

        dragging = true;
        moved = true;
        el.style.scrollSnapType = 'none';
        el.style.scrollBehavior = 'auto';
        el.classList.add('ost-dragging');
        try { el.setPointerCapture(pid); } catch (err) { /* egal */ }
      }

      var dt = e.timeStamp - lastT;
      if (dt > 0) vx = (e.clientX - lastX) / dt;
      lastX = e.clientX;
      lastT = e.timeStamp;

      el.scrollLeft = startLeft - dx;
      e.preventDefault();
    });

    el.addEventListener('pointerup', function (e) {
      if (e.pointerId !== pid) return;
      if (dragging) stopDrag(); else pid = null;
    });

    el.addEventListener('pointercancel', function (e) {
      if (e.pointerId !== pid) return;
      if (dragging) stopDrag(); else pid = null;
    });

    /* Nach einem Zieh-Vorgang darf der Klick nicht durchschlagen, sonst
       oeffnet das Wischen ueber eine Karte deren Link. */
    el.addEventListener('click', function (e) {
      if (!moved) return;
      moved = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    /* Bilder haengen sonst am Mauszeiger. */
    el.addEventListener('dragstart', function (e) {
      if (dragging) e.preventDefault();
    });
  }

  function scan() {
    var all = document.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (isScroller(all[i])) enhance(all[i]);
    }
  }

  /* Mehrfach scannen: Schriften, Bilder und nachgeladene Sections aendern die
     Breite und machen aus einem stillen Container nachtraeglich einen
     Scroller. `enhance` laeuft pro Element nur einmal (READY-Attribut). */
  function boot() {
    scan();
    setTimeout(scan, 400);
    setTimeout(scan, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', scan);

  var tid = null;
  window.addEventListener('resize', function () {
    if (tid) clearTimeout(tid);
    tid = setTimeout(scan, 200);
  });

  /* Theme-Editor: neu geladene Sections nachziehen. */
  document.addEventListener('shopify:section:load', function () { setTimeout(scan, 60); });

  window.ostSliderScan = scan;
})();
